// extracted by mini-css-extract-plugin
export default {"last-seen":"xOJqrNKxlb","lastSeen":"xOJqrNKxlb"};